import type { Hand } from '../../types/problems';

interface HandDisplayProps {
  hand: Hand;
}

const SUIT_CONFIG = [
  { key: 'spades' as const, symbol: '\u2660', color: 'text-black', name: 'Spades' },
  { key: 'hearts' as const, symbol: '\u2665', color: 'text-red-600', name: 'Hearts' },
  { key: 'diamonds' as const, symbol: '\u2666', color: 'text-red-600', name: 'Diamonds' },
  { key: 'clubs' as const, symbol: '\u2663', color: 'text-black', name: 'Clubs' },
];

export function HandDisplay({ hand }: HandDisplayProps) {
  const getCardDisplay = (cards: string): string => {
    // Show empty space for empty, null, undefined, or "Void" values
    if (!cards || cards.toLowerCase() === 'void') {
      return '';
    }
    return cards;
  };

  return (
    // FR-019: 2em suit symbols; FR-021: 0.1em gap, 1em suit width
    // FR-004: 1rem body text (from problemStyles.ts)
    // .hand-suits: stable hook so index.css can switch suits to a compact
    // horizontal row for N/S seats on short viewports (feature 016).
    <div className="hand-suits space-y-0" data-testid="hand-display">
      {SUIT_CONFIG.map((suit) => (
        <div key={suit.key} className="py-0 leading-none">
          {/* Suit symbol */}
          <span
            className={`${suit.color} inline-block align-middle text-[1.5rem] text-center font-suits`}
            style={{ width: '1em' }}
            title={suit.name}
          >
            {suit.symbol}
          </span>
          {/* Card text */}
          <span className="font-semibold text-ink tracking-wide align-middle" style={{ marginLeft: '0.1em' }}>
            {getCardDisplay(hand[suit.key])}
          </span>
        </div>
      ))}
    </div>
  );
}
